import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { AnimationOptions, LottieModule } from 'ngx-lottie';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    LottieModule,
  ],
})
export class AppComponent implements OnInit {
  public isLoading$?: Observable<boolean>;
  public isHebrew$?: Observable<boolean>;

  constructor() {}

  ngOnInit() {}
  public title = 'avis-rent-kiosk';

  public lottieOptions: AnimationOptions = {
    path: '/assets/lotties/car-loading.json',
  };
  public lottieStyles: Partial<CSSStyleDeclaration> = {
    margin: '400px auto',
    width: '250px',
    height: '250px',
  };
  public lottieStylesHeb: Partial<CSSStyleDeclaration> = {
    margin: '400px auto',
    width: '250px',
    height: '250px',
    transform: 'scaleX(-1)',
  };
}
